import {
  FiHome,
  FiTruck,
  FiLayout,
  FiCheckCircle,
  FiTool,
  FiSun,
  FiWind,
  FiZap,
  FiSettings
} from 'react-icons/fi';

export const companyData = {
  name: "Oscar Terrassen",
  address: "Alte Schmiede 54, 52525 Heinsberg",
  phone: "0177 244 58 37",
  phoneLandline: "02452 187 88 31",
  email: "info@oscar-terrassen.de",
  website: "oscar-terrassen.de",
  region: "Heinsberg, Aachen, Mönchengladbach, Erkelenz & Umgebung"
};

export const navigation = [
  { name: 'Startseite', path: '/' },
  { name: 'Konfigurator', path: '/konfigurator' },
  {
    name: 'Informationen',
    subItems: [
      { name: 'Leistungen', path: '/leistungen' },
      { name: 'Ablauf', path: '/ablauf' },
      { name: 'Über Uns', path: '/ueber-uns' }
    ]
  },
  { name: 'Blog', path: '/blog' },
  { name: 'Kontakt', path: '/kontakt' },
];

export const slogans = [
  "Mehr Lebensraum & Wohnkomfort im Freien – durch maßgeschneiderte Lösungen.",
  "Schutz vor Wind & Wetter – damit Terrasse und Garten optimal geschützt sind.",
  "Individuelle & hochwertige Lösungen – abgestimmt auf Hausstil und Budget.",
  "Professionelle Beratung & Montage – vom Aufmaß bis zur fertigen Installation.",
  "Materialqualität & Langlebigkeit mit attraktiven Design-Optionen."
];

export const heroContent = {
  headlines: [
    "Machen Sie Ihre Terrasse zum Lieblingszimmer – bei jedem Wetter.",
    "Premium Terrassen & Wintergärten aus Heinsberg.",
    "Ihr wetterfester Logenplatz im eigenen Garten."
  ],
  subheadlines: [
    "Maßgefertigte Lösungen aus Aluminium & Glas. Inklusive Planung & Montage.",
    "Ihr Fachbetrieb für Heinsberg, Aachen & Umgebung. Jetzt Beratung sichern.",
    "Verlängern Sie die Gartensaison mit unseren langlebigen Konstruktionen."
  ]
};

export const services = [
  {
    id: "terrassenueberdachung",
    title: "Terrasse",
    shortDesc: "Schutz & Komfort im Außenbereich durch hochwertige Materialien.",
    icon: FiHome,
    details: "Unsere Terrassen- und Balkondächer aus Aluminium, Stahl oder Holz schaffen einen geschützten, wohnlichen Außenbereich – ideal für Erholung und gesellige Stunden im Freien. Wir erweitern Ihren Wohnraum optisch passend zum Haus.",
    features: [
      "Maßgefertigt & Individuell",
      "Sicherheitsglas (VSG)",
      "Robustes Aluminium",
      "Optionale Markisen"
    ]
  },
  {
    id: "carport",
    title: "Carport",
    shortDesc: "Funktionaler Fahrzeugschutz vor Sonne, Regen, Hagel und Schnee.",
    icon: FiTruck,
    details: "Weit mehr als nur eine schlichte Überdachung: Unsere Carports sind gestaltende Elemente im Außenbereich. Auf Wunsch mit Seitenteilen oder sogar integrierten PV-Lösungen zur Stromerzeugung.",
    features: [
      "Einzel- & Doppelcarports",
      "PV-Lösung (Photovoltaik)",
      "Wetterbeständig",
      "Harmonisches Design"
    ]
  },
  {
    id: "wintergarten",
    title: "Wintergarten",
    shortDesc: "Ganzjähriger Wohnraum im Grünen – lichtdurchflutet und elegant.",
    icon: FiLayout,
    details: "Wintergärten verbinden Haus und Garten und ermöglichen Naturerlebnis unabhängig von der Jahreszeit. Hochwertige Dämmtechnik sorgt für angenehme Temperaturen und maximale ästhetische Qualität.",
    features: [
      "Wohnraum-Erweiterung",
      "Ausgereifte Dämmtechnik",
      "Große Glasflächen",
      "Wertsteigerung der Immobilie"
    ]
  }
];

export const additionalServices = [
  {
    title: "Beratung & Planung",
    desc: "Professionelle Bedarfsanalyse und detaillierte Planung passend zur Architektur.",
    icon: FiSun
  },
  {
    title: "Montage & Service",
    desc: "Fachgerechter Aufbau durch erfahrene Teams – von der Vorbereitung bis zur Fertigstellung.",
    icon: FiTool
  },
  {
    title: "Wartung & Pflege",
    desc: "Langfristiger Service zur Funktionssicherheit und Werterhaltung Ihres Projekts.",
    icon: FiZap
  }
];

export const processSteps = [
  {
    step: 1,
    title: "Beratung",
    desc: "Kostenloses Erstgespräch und Bedarfsanalyse."
  },
  {
    step: 2,
    title: "Planung",
    desc: "Individuelles Aufmaß und technisches Design."
  },
  {
    step: 3,
    title: "Montage",
    desc: "Fachgerechte Installation durch unsere Experten."
  },
  {
    step: 4,
    title: "Service",
    desc: "Langfristige Betreuung und Wartung."
  }
];

export const trustElements = [
  "Meistergeführter Fachbetrieb",
  "Individuelle Maßanfertigung",
  "Festpreis-Garantie",
  "Regionale Qualität aus Heinsberg"
];

export const seoKeywords = {
  short: ["Terrasse", "Wintergarten", "Carport", "Markisen", "Heinsberg", "Oscar Terrassen"],
  longtail: ["Terrassenbau Alu Glas", "Wintergarten kaufen Heinsberg", "Carport mit Solar", "Individuelle Überdachung nach Maß"],
  local: ["Heinsberg", "Aachen", "Mönchengladbach", "Erkelenz", "Wegberg", "Hückelhoven", "Geilenkirchen"]
};